// Contact limits per Fluxi membership plan. Source of truth for both the
// chat inbox counter (`X / limit contactos`) and the plans page feature list.
//
// Ideally this would live as a column on the `benefit_plans` table in
// ecommerce-service and be returned in the active-membership endpoint, but
// we're mapping by plan name for now so we don't block on a cross-service
// change. Matches plan names seeded in
// ecommerce-service migrations-subscription/V6, V17.

const LOWER = (s: string) => s.toLowerCase().trim();

const PLAN_CONTACT_LIMITS: Record<string, number> = {
  "plan lite": 0,
  "plan básico": 500,
  "plan basico": 500,
  "plan medio": 2000,
  "plan avanzado": 5000,
  "plan master": 10000,
};

export const DEFAULT_CONTACT_LIMIT = 500;

/** Resolve the contact limit for a given plan name (case / accent tolerant). */
export function contactLimitForPlan(planName: string | null | undefined): number {
  if (!planName) return DEFAULT_CONTACT_LIMIT;
  const key = LOWER(planName);
  if (PLAN_CONTACT_LIMITS[key] != null) return PLAN_CONTACT_LIMITS[key];
  // Fallback: match by the last word (e.g., "Plan Master USD" → "master")
  const words = key.split(/\s+/);
  const last = words[words.length - 1];
  const byLast = PLAN_CONTACT_LIMITS[`plan ${last}`];
  if (byLast != null) return byLast;
  return DEFAULT_CONTACT_LIMIT;
}
